import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Button from "../../../../components/Button";
import { AuthContext } from '../../../../contexts/AuthContext';
import { Modules, RouteParamsTypes, PermissionModulesEnum, PermissionActionsEnum } from "../../../../enums";
import { hasResourseAccess } from '../../../../utils/methods';
import { VALIDATION_FIELD_MAPPING } from "../../../../utils/appConstant";
import { TransactionStatus } from "../../../../interfaces/transaction.interface";

interface HeaderProps {
  id?: string;
  loading: boolean;
  view: boolean;
  transactionStatus: TransactionStatus | ''
}

const Header: React.FC<HeaderProps> = ({ id, loading, view, transactionStatus }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { isSystemAdmin, permissions } = useContext(AuthContext);

  const hasEditAccess = hasResourseAccess(isSystemAdmin, permissions, { accessibleTo: [{ [PermissionModulesEnum.Reservation]: [PermissionActionsEnum.Update] }] })
  const hasListAccess = hasResourseAccess(isSystemAdmin, permissions, { accessibleTo: [{ [PermissionModulesEnum.Reservation]: [PermissionActionsEnum.View] }] })

  const handleGoToListClick = () => {
    navigate(Modules.reservations);
  };

  const handleEditButtonClick = () => {
    navigate(`${Modules.reservations}${RouteParamsTypes.edit}/${id}`);
  }

  return (
    <div className="row mb-6">
      <div className="col-6">
        <h4 className="m-0 fw-bold">{t("reservations.edit.pageTexts.header.title")}</h4>
        <p>{t("reservations.edit.pageTexts.header.subTitle")}</p>
      </div>
      <div className="col-6 d-flex align-items-center justify-content-end gap-3">
        {
          view && !loading && hasEditAccess && (transactionStatus != VALIDATION_FIELD_MAPPING.settled) && (
            <Button
              className="btn btn-primary waves-effect waves-light mt-xs-3"
              text={t("reservations.edit.pageTexts.header.editBtn")}
              onClick={() => handleEditButtonClick()}
            />
          )
        }
        {
          hasListAccess && (
            <Button
              className="btn btn-primary waves-effect waves-light"
              onClick={handleGoToListClick}
              text={t("reservations.edit.pageTexts.header.goToList")}
            />
          )
        }
      </div>
    </div>
  );
}

export default Header;